<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <b-row>
                            <b-col md="4" class="text-start">
                                <strong>Origin Master</strong>
                            </b-col>
                            <b-col md="8" class="text-right">
                                <a :href="csvurl" target="_blank">
                                    <b-button variant="primary" size="sm" @click="downloadcsv()">
                                        <i class="fa fa-download"></i> Download ClusterMaster
                                    </b-button>
                                </a>&nbsp;
                                <b-button variant="primary" size="sm" @click="addorigin()"><i class="fa fa-plus" aria-hidden="true"></i>
                                    Add Origin 
                                </b-button>&nbsp;
                                <b-button variant="primary" size="sm" @click="search()"><i class="fa fa-search" aria-hidden="true"></i> Search</b-button>&nbsp;
                                <b-button variant="primary" size="sm" @click="resetclear()"><i class="fa fa-search"></i> Reset Search Filter</b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <div v-if="add_origininfo">
                        <div>
                            <h4>Add Origin Master</h4>
                            <hr>
                            <b-form
                            @submit.prevent="validateForm('form-1')"
                            data-vv-scope="form-1">
                                <div class="row mt-3">
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Client Name</b> <span style="color:red;"> *</span></label>
                                                <v-select name="ClientName" v-model="customer.ClientName" :options="clientname" 
                                                placeholder="Select Destination Client Name"
                                                v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.ClientName'),
                                                }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('ClientName')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.ClientName')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.ClientName") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Origin Type</b> <span style="color:red;"> *</span></label>
                                                <v-select name="originType" 
                                                placeholder="Select Origin Type"
                                                v-model="customer.originType" :options="optionorigin" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.originType'),
                                                }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originType')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.originType')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.originType") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Origin Name</b> <span style="color:red;"> *</span></label>
                                                <b-form-input type="text" name="originName" v-model.trim="customer.originName" placeholder="Origin Name" class="italic-placeholder" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.originName'),
                                                }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originName')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.originName')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.originName") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <!-- ~~~~~~~~~~~~~~ -->
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>FC Origin ID</b> <span style="color:red;"> *</span></label>
                                                <b-form-input type="text" name="originID" v-model.trim="customer.originID" placeholder="FC Origin ID" class="italic-placeholder" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.originID'),
                                                }"></b-form-input>
                                                <b-input-group class="mb-3">
                                                    <span class="icon has-text-warning">
                                                    <i
                                                        class="fa fa-warning"
                                                        v-show="errors.has('originID')"
                                                    ></i>
                                                    </span>
                                                    <span
                                                    style="width:240px"
                                                    v-show="errors.has('form-1.originID')"
                                                    class="help text-danger"
                                                    >{{ errors.first("form-1.originID") }}</span
                                                    >
                                                </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <!-- <b-form-group>
                                            <label><b>Country Name</b> <span style="color:red;"> *</span></label>
                                                <b-form-input name="originCountry" 
                                                placeholder="Select Origin Country" v-model="customer.originCountry" v-validate="'required|alpha_spaces'"
                                                :class="{ input: true, 'tis-invalid': errors.has('form-1.originCountry'),
                                                }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originCountry')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.originCountry')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.originCountry") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group> -->
                                        <b-form-group>
                                            <label><b>Country Name</b> <span style="color:red;"> *</span></label>
                                            <v-select  name="Origin Country" 
                                            placeholder="Select Origin Country" v-model="customer.originCountry" v-validate="'required'"
                                            :class="{ input: true, 'tis-invalid': errors.has('form-1.Origin Country'),
                                            }" :options="country" @input="selectcountry('country',customer.originCountry)"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Origin Country')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Origin Country')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Origin Country") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <!-- <b-form-group>
                                            <label><b>Origin State</b> <span style="color:red;"> *</span></label>
                                                <b-form-input name="originState" 
                                                placeholder="Select Origin State" v-model="customer.originState" v-validate="'required|alpha_spaces'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.originState'),
                                                }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originState')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.originState')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.originState") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group> -->
                                        <b-form-group>
                                            <label><b>Origin State</b> <span style="color:red;"> *</span></label>
                                            <v-select  name="Origin State" 
                                            placeholder="Select Origin State" v-model="customer.originState" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Origin State'),
                                            }" @input="selectstate('city',customer.originCountry,customer.originState)" :disabled="!customer.originCountry"  :options="StateList"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Origin State')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Origin State')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Origin State") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                    
                                    <!-- ~~~~~~~~~~~~~~ -->        
                                    <div class="col-md-4">
                                        <!-- <b-form-group>
                                            <label><b>Origin City</b> <span style="color:red;"> *</span></label>
                                                <b-form-input name="originCity"      
                                                placeholder="Select Origin City"   v-model="customer.originCity" v-validate="'required|alpha_spaces'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.originCity'),
                                                }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originCity')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.originCity')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.originCity") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group> -->

                                        <b-form-group>
                                            <label><b>Origin City</b> <span style="color:red;"> *</span></label>
                                            <v-select  @input="selectcity('pincode',customer.originCountry,customer.originState,customer.originCity)" :disabled="!customer.originState" :options="CityList"  name="Origin City"      
                                            placeholder="Select Origin City"   v-model="customer.originCity" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Origin City'),
                                            }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Origin City')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Origin City')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Origin City") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <!-- <b-form-group>
                                            <label><b>Origin Pincode</b> <span style="color:red;"> *</span></label>
                                                <b-form-input type="text" name="originPincode" v-model="customer.originPincode" placeholder="Pincode" class="italic-placeholder" v-validate="'required|digits:6'" pattern=".{6,6}" maxlength="6"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.originPincode'),
                                                }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originPincode')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.originPincode')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.originPincode") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group> -->
                                        
                                        <b-form-group>
                                            <label><b>Origin Pincode</b> <span style="color:red;"> *</span></label>
                                            <v-select name="Origin Pincode" v-model="customer.originPincode" placeholder="Select Origin Pincode" class="italic-placeholder" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Origin Pincode'),
                                            }"  :disabled="!customer.originCity" :options="PincodeList"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Origin Pincode')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Origin Pincode')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Origin Pincode") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Origin Address</b> <span style="color:red;"> *</span></label>
                                                <b-form-input type="text" name="originAddress" v-model.trim="customer.originAddress" placeholder="Origin Address" class="italic-placeholder" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.originAddress'),
                                                }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originAddress')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.originAddress')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.originAddress") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <!-- ~~~~~~~~~~~~~~ -->   
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Origin Mail ID</b> <span style="color:red;"> *</span></label>
                                                <b-form-input name="originMailId" v-model.trim="customer.originMailId" placeholder="Origin Mail ID" class="italic-placeholder" v-validate="'required|email'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.originMailId'),
                                                }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originMailId')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.originMailId')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.originMailId") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>     
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Origin Phone no.</b> <span style="color:red;"> *</span></label>
                                                <b-form-input name="originPhone" v-model.trim="customer.originPhone" placeholder="Origin Phone no." class="italic-placeholder" v-validate="'required|digits:10'"  maxlength="10"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.originPhone'),
                                                }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originPhone')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.originPhone')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.originPhone") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Origin POC</b> <span style="color:red;"> *</span></label>
                                                <b-form-input name="originPoc" v-model.trim="customer.originPoc" placeholder="Origin POC" class="italic-placeholder" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.originPoc'),
                                                }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originPoc')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.originPoc')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.originPoc") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>     
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Origin Lat and Long</b> <span style="color:red;"> *</span></label>
                                            <div @mouseenter="showMessage()" @mouseleave="hideMessage()">
                                                <b-form-input name="originLatLong"    
                                                placeholder="Select Origin Lat and Long"   v-model.trim="customer.originLatLong" @focus="hideMessage()" @input="showMessage()" @blur="hideMessage()"   v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.originLatLong'),
                                                }"></b-form-input>
                                            </div>
                                                
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originLatLong')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.originLatLong')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.originLatLong") }}</span
                                                >
                                            </b-input-group>
                                            <h6 v-if="showMsg"><pre style="color: rgb(245 51 50);font-size: 11px;">Lat/Long like this format 18.5172010,73.85191348</pre></h6>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Select Constraint</b> <span style="color:red;"> *</span></label>
                                            <ejs-multiselect id='multiselect' :dataSource='constrainlist' placeholder="Select Constraint" mode="CheckBox" :fields='fields1' v-model="customer.constraint_id" name="Constraint" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Constraint'),
                                            }"></ejs-multiselect>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Constraint')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Constraint')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Constraint") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>WeekOff</b> <span style="color:red;"> *</span></label>
                                                <b-input-group>
                                                    <ejs-multiselect id='multiselect' :dataSource='weekofforigin' placeholder="Select Origin WeekOff" mode="CheckBox" v-model="customer.originWeekoff" name="originWeekoff" v-validate="'required'"
                                                    :class="{ input: true, 'is-invalid': errors.has('form-1.originWeekoff'),
                                                    }"></ejs-multiselect>
                                                </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originWeekoff')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.originWeekoff')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.originWeekoff") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <b>IS Active <span style="color: red;">*</span></b>
                                            <b-form-select v-model="customer.selectedstatus" :options="optionsactive" class="mt-2" name="status" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.status'),
                                            }"></b-form-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('status')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.status')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.status") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>

                                
                                    <div class="col-md-12 mt-1 text-right">
                                        <b-button variant="primary" type="submit" class="mr-2"><i class="fa fa-dot-circle-o"></i> Add</b-button>
                                        <b-button variant="danger" @click="clear()" class="mr-2"><i class="fa fa-ban"></i> Clear</b-button>
                                    </div>
                                    
                                </div>
                            </b-form>
                        </div>
                    </div>

                    <div v-if="search_origin">
                        <div>
      
                            <h4>Search Origin</h4>
                            <hr>
                            <div class="row mt-3">
                                
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin Name</b></label>
                                        <b-input-group>
                                            <b-form-input type="text" name="originName" v-model.trim="originName" placeholder="Origin Name" class="italic-placeholder"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                 <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin City</b></label>
                                        <b-input-group>
                                            <b-form-input name="originCity" v-model.trim="originCity"  placeholder="Origin City" class="italic-placeholder"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin Pincode</b></label>
                                        <b-input-group>
                                            <b-form-input type="text" name="originPincode" v-model.trim="originPincode" placeholder="Pincode" pattern=".{6,6}" class="italic-placeholder"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Group Name</b></label>
                                        <b-input-group>
                                            <b-form-input type="text" name="groupname" v-model.trim="groupname" placeholder="Group Name" class="italic-placeholder"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Group ID</b></label>
                                        <b-input-group>
                                            <b-form-input type="text" name="groupID" v-model.trim="groupID" placeholder="Group ID" class="italic-placeholder"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin Type </b></label>
                                        <b-input-group>
                                            <b-form-select name="sourcetype" v-model.trim="sourcetype" :options="optionorigin_type"></b-form-select>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-12 text-right" >
                                    <b-button variant="primary" @click="originmasterlist(pageNum)" class="mr-2"><i class="fa fa-dot-circle-o"></i> search</b-button>
                                    <b-button variant="danger" @click="clear()" class="mr-2"><i class="fa fa-ban"></i> Clear</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br><br>
                    <div>
                        <b-row>
                            <b-col md="12" class="text-right">
                                <b text-variant="red">Total Records :<span style="color: red;"> {{totalRows}}</span></b>
                            </b-col>
                            <b-col md="12">
                                <b-table show-empty responsive :items="items" :fields="fields" :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy">
                                    <div slot="table-busy" class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>  
                                    <template slot="sno" slot-scope="row">
                                        <div>
                                            {{ row.index+1 }}
                                        </div>
                                    </template>
                                    <template slot="isactive" slot-scope="row">
                                        <span class="badge badge-success" v-if="row.item.isactive=='1'" style="cursor: pointer;" @click="activeInactive(row.item)">
                                            Active
                                        </span>
                                        <span class="badge badge-danger"  v-if="row.item.isactive=='0'" style="cursor: pointer;" @click="activeInactive(row.item)">In Active</span>

                                        <span class="badge badge-success" v-if="row.item.isactive=='Yes'" style="cursor: pointer;" @click="activeInactive(row.item)">
                                            Active
                                        </span>
                                        <span class="badge badge-danger"  v-if="row.item.isactive=='No'" style="cursor: pointer;" @click="activeInactive(row.item)">In Active</span>
                                        
                                    </template>
                                    <template slot="origin_latlng" slot-scope="row">
                                        <div>
                                            {{ row.item.origin_latlng!=null&&row.item.origin_latlng!=""?row.item.origin_latlng.replace(/[\(\)']+/g,''):"" }}
                                        </div>
                                    </template>
                                    <template slot="action" slot-scope="row">
                                        <div>
                                            <b-button size="sm" @click="editoriginmodelopen(row.item,row.index)"><i class="fa fa-pencil" ></i></b-button>
                                        </div>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </div>

                    <b-row>
                        <b-col sm="12" class="text-right">
                          <br>
                               <p style="margin-top: 5px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
                        </b-col>
                        <b-col md="12" class="my-1" >
                            <paginate 
                            v-model="pageNum"
                                :page-count="noofpages"
                                :page-range="10"
                                :margin-pages="2"
                                :click-handler="clickCallback"
                                :prev-text="'Prev'"
                                :next-text="'Next'"
                                :container-class="'pagination'"
                                :page-class="'page-item'">
                            </paginate>
                        </b-col>   
                    </b-row> 

                    <b-modal title="Update Origin Master" v-model="showoriginModal" size="xl" @ok="showoriginModal = false" hide-footer>
                        <b-form
                        @submit.prevent="validateForm1('form-2')"
                        data-vv-scope="form-2">
                            <div class="row mt-3">
                                <div id="overlaymodel" >
                                    <div class="modelloader"></div>
                                  </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Client Name</b> <span style="color:red;"> *</span></label>
                                            <v-select name="ClientName" v-model="user.ClientName" :options="clientname" 
                                            placeholder="Select Destination Client Name"
                                            v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.ClientName'),
                                            }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('ClientName')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.ClientName')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.ClientName") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin Type</b> <span style="color:red;"> *</span></label>
                                            <v-select name="originType" 
                                            placeholder="Select Origin Type"
                                            v-model="user.originType" :options="optionorigin" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originType'),
                                            }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('originType')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.originType')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.originType") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin Name</b> <span style="color:red;"> *</span></label>
                                            <b-form-input type="text" name="originName" v-model.trim="user.originName" placeholder="Origin Name" class="italic-placeholder" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originName'),
                                            }"></b-form-input>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('originName')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.originName')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.originName") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <!-- ~~~~~~~~~~~~~~ -->
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>FC Origin ID</b> <span style="color:red;"> *</span></label>
                                            <b-form-input type="text" name="originID" v-model.trim="user.originID" placeholder="FC Origin ID" class="italic-placeholder" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originID'),
                                            }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('originID')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-2.originID')"
                                                class="help text-danger"
                                                >{{ errors.first("form-2.originID") }}</span
                                                >
                                            </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Country Name</b> <span style="color:red;"> *</span></label>
                                        <!-- <v-select name="Origin Pincode" v-model="customer.originPincode" placeholder="Select Origin Pincode" class="italic-placeholder" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Origin Pincode'),
                                            }"  :disabled="!customer.originCity" :options="PincodeList"></v-select> -->

                                            <v-select name="originCountry" 
                                            placeholder="Select Origin Country" v-model="user.originCountry" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originCountry'),
                                            }" :options="country" @input="editstatelist('country',user.originCountry)"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('originCountry')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.originCountry')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.originCountry") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin State</b> <span style="color:red;"> *</span></label>
                                            <!-- <b-form-input name="originState" 
                                            placeholder="Select Origin State" v-model="user.originState" v-validate="'required|alpha_spaces'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originState'),
                                            }"></b-form-input> -->
                                            <v-select name="originState" 
                                            placeholder="Select Origin State" v-model="user.originState" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originState'),
                                            }" :options="StateList" @input="editcitylist('city',user.originCountry,user.originState)" :disabled="!user.originCountry"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('originState')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.originState')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.originState") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                
                                <!-- ~~~~~~~~~~~~~~ -->        
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin City</b> <span style="color:red;"> *</span></label>
                                            <!-- <b-form-input name="originCity"      
                                            placeholder="Select Origin City"   v-model="user.originCity" v-validate="'required|alpha_spaces'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originCity'),
                                            }"></b-form-input> -->
                                            <v-select name="originCity"      
                                            placeholder="Select Origin City"   v-model="user.originCity" v-validate="'required|alpha_spaces'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originCity'),
                                            }" :options="CityList" @input="editpincodelist('pincode',user.originCountry,user.originState,user.originCity)" :disabled="!user.originState"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('originCity')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.originCity')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.originCity") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin Pincode</b> <span style="color:red;"> *</span></label>
                                            <!-- <b-form-input type="text" name="originPincode" v-model="user.originPincode" maxlength="6" placeholder="Pincode" class="italic-placeholder" v-validate="'required|digits:6'" pattern=".{6,6}"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originPincode'),
                                            }"></b-form-input> -->
                                            <v-select name="originPincode" v-model="user.originPincode" placeholder=" Select Pincode" class="italic-placeholder" v-validate="'required'" 
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originPincode'),
                                            }" :options="PincodeList" :disabled="!user.originCity"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('originPincode')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.originPincode')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.originPincode") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin Address</b> <span style="color:red;"> *</span></label>
                                            <b-form-input type="text" name="originAddress" v-model.trim="user.originAddress" placeholder="Origin Address" class="italic-placeholder" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originAddress'),
                                            }"></b-form-input>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('originAddress')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.originAddress')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.originAddress") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <!-- ~~~~~~~~~~~~~~ -->   
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin Mail ID</b> <span style="color:red;"> *</span></label>
                                            <b-form-input name="originMailId" v-model.trim="user.originMailId" placeholder="Origin Mail ID" class="italic-placeholder" v-validate="'required|email'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originMailId'),
                                            }"></b-form-input>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('originMailId')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.originMailId')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.originMailId") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>     
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin Phone no.</b> <span style="color:red;"> *</span></label>
                                            <b-form-input name="originPhone" v-model.trim="user.originPhone" placeholder="Origin Phone no." class="italic-placeholder" v-validate="'required|digits:10'"  maxlength="10"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originPhone'),
                                            }"></b-form-input>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('originPhone')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.originPhone')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.originPhone") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin POC</b> <span style="color:red;"> *</span></label>
                                            <b-form-input name="originPoc" v-model.trim="user.originPoc" placeholder="Origin POC" class="italic-placeholder" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originPoc'),
                                            }"></b-form-input>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('originPoc')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.originPoc')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.originPoc") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>     
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Origin Lat and Long</b> <span style="color:red;"> *</span></label>
                                        <div @mouseenter="showMessage()" @mouseleave="hideMessage()">
                                            <b-form-input name="originLatLong"    
                                            placeholder="Select Origin Lat and Long"   v-model.trim="user.originLatLong" @focus="hideMessage()" @input="showMessage()" @blur="hideMessage()" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.originLatLong'),
                                            }"></b-form-input>
                                        </div>
                                        <!-- // -->
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('originLatLong')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.originLatLong')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.originLatLong") }}</span
                                            >
                                        </b-input-group>
                                        <h6 v-if="showMsg"><pre style="color: rgb(245 51 50); font-size: 11px;">Lat/Long like this format 18.5172010,73.85191348</pre></h6>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Select Constraint</b> <span style="color:red;"> *</span></label>
                                        <ejs-multiselect id='multiselect' :dataSource='constrainlist' placeholder="Select Constraint"  @change="handleconstraintChange" :fields='fields1' v-model="user.constraint_id" name="Constraint" v-validate="'required'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-2.Constraint'),
                                        }"></ejs-multiselect>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Constraint')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.Constraint')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.Constraint") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>WeekOff</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <ejs-multiselect id='multiselect' :dataSource='weekofforigin' placeholder="Select Origin WeekOff" v-model="user.originWeekoff" @change="handleSelectionChange"  name="originWeekoff" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-2.originWeekoff'),
                                                }"></ejs-multiselect>
                                            </b-input-group>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('originWeekoff')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.originWeekoff')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.originWeekoff") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <b>IS Active <span style="color: red;">*</span></b>
                                        <b-form-select v-model="user.selectedstatus" :options="optionsactive" class="mt-2" name="status" v-validate="'required'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-2.status'),
                                        }"></b-form-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('status')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.status')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.status") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>

                                
                                <div class="col-md-12 mt-1 text-right">
                                    <b-button variant="primary" type="submit" class="mr-2"><i class="fa fa-dot-circle-o"></i> Update</b-button>
                                    <b-button variant="danger" @click="clear()" class="mr-2"><i class="fa fa-ban"></i> Clear</b-button>
                                </div>
                                
                            </div>
                        </b-form>
                    </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";

export default {
    data() {
        return {
            isBusy : false,
            totalRows :0,
            items :[],
            fields :[
                {key:'sno',label:'S.No'},
                {key:'origin_id',label:'Origin ID'},
                {key:'origin_name',label:'Origin Name'},
                {key:'origingroup_id',label:'Group ID'},
                {key:'origin_group_name',label:'Group Name'},
                {key:'clientname',label:'Client Name'},
                {key:'origin_country',label:'Country'},
                {key:'origin_state',label:'State'},
                {key:'origin_city',label:'City'},
                {key:'origin_pincode',label:'Pincode'},
                {key:'origin_latlng',label:'Lat/Long'},
                {key:'origin_type',label:'Origin Type'},
                {key:'isactive',label:'Is Active'},
                {key:'createdby',label:'Created By'},
                {key:'createddate',label:'Created Date'},
                {key:'lastmodifiedby',label:'Updated By'},
                {key:'lastmodifieddate',label:'Updated Date'},
                {key:'action',label:'Edit'},

            ],

            //add start
            add_origininfo : false,
            customer :{
                originWeekoff :[],
                selectedstatus:null,
                constraint_id :[]
            },
            clientnamelist: [],
            clientname :[],
            optionorigin_type : [ 
                { value: null, text: 'Please select status' },
                { value: 'Stockist', text: 'Stockist' },
                { value: 'Warehouse', text: 'Warehouse' },
                { value: 'Vendor', text: 'Vendor' },
            ],
            optionorigin :["Stockist","Warehouse","Vendor"],
            optionsactive : [ 
                { value: null, text: 'Please select status' },
                { value: 'Yes', text: 'Yes' },
                { value: 'No', text: 'No' },
            ],
            weekofforigin: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
            //add end

            //search start
            search_origin :false,
            originName :'',
            originCity :'',
            originPincode :'',
            groupname:'',
            groupID:'',
            sourcetype :null,
            //search end 

            //pagination 
            currentPage: 1,
            perPage:  20,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            noofpages:'',
            pageNum:1,
            listingpageno:1,
            //end pagi 


            items_ConstraintList :[],
            constrainlist :[],
            fields1 : { text: 'label', value: 'key' },
            //csv
            csvurl:'',

            //edit start
            showoriginModal : false,
            user:{
                originWeekoff :[],
                selectedstatus:null,
                constraint_id :[]
            },
            origin_masterid :'',
            showMsg: false,
            //edit end 

            //country
            Obj :{},
            country:["India"],
            item_state :[],
            StateList:[],
            item_city : [],
            CityList : [],
            item_pincode : [],
            PincodeList : [],
        }
    },
    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.allclientlist()
        this.ConstraintList()
        this.originmasterlist(this.pageNum)
        this.getStateList('country')
    },

    methods: {

        activeInactive(data){
            console.log("data",data)
            this.$fire({
                text: data.isactive=='Yes'?"Do you want to change the status In Active?":"Do you want to change the status Active?",
                type: "warning",
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                showLoaderOnConfirm: true 
            }).then((result) => {
                console.log("result", result)
                /* Read more about isConfirmed, isDenied below */
                if (result.value) {
                    document.getElementById("overlay").style.display = "block";
                    var userdata = localStorage.getItem("userData");
                    var userInfo = JSON.parse(userdata);

                    const obj = {
                        id : `${data.id}`,
                        isActive : data.isactive=='Yes'?'No':'Yes',
                        lastmodifiedby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                    } 
                    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateIsActiveOriginMaster`,obj)
                    .then((result) => {
                        console.log("result",result)
                        document.getElementById("overlay").style.display = "none";
                        if (result.body.returnmsg=="Successful") {
                            this.$fire({
                                text: result.body.returnmsg,
                                type: "success",
                                timer: 30000,
                            });
                            this.originmasterlist(this.pageNum)
                        }
                        else{
                            this.$fire({
                                text: result.body.returnmsg,
                                type: "error",
                                timer: 30000,
                            });
                        }
                    })
                    .catch((ex) => {
                        console.log("error", ex);
                    });
                } else if (result.dismiss) {
                    this.$fire({
                        text: 'Status Is Not Changes',
                        type: "error",
                        timer: 30000,
                    });
                }
            });
        },

        showMessage() {
            console.log("++++++++++++++++++++++++++")
            this.showMsg = true;
        },

        hideMessage() {
            console.log("--------------------")
            this.showMsg = false;
        },

        downloadcsv(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.csvurl = `${CONSTANTS.MIGRATION_API_URL}/getoriginmasterListCsv?sysusermasterid=`+ userInfo.sysusermasterid+`&origin_name=`+this.originName+`&origin_type`+(this.sourcetype==null?'':this.sourcetype)+`&origin_city`+this.originCity+`&origin_pincode`+this.originPincode

            console.log("csvurl",this.csvurl)
        },

        addorigin(){
            this.clear()
            // this.allclientlist()
            // this.getStateList('country')
            this.add_origininfo=!this.add_origininfo;
            this.search_origin=false;
        },

        search(){
            this.clear()
            this.search_origin=!this.search_origin;
            this.add_origininfo=false;
        },

        resetclear(){
            this.search_origin=false;
            this.add_origininfo=false
            this.pageNum=1;
            this.totalRows = 0;
            this.customer ={
                originCountry : '',
                originState : '',
                originCity : '',
                originPincode : '',
                originWeekoff :[],
                selectedstatus:null,
                constraint_id :[]
            }
            this.originName ='';
            this.originCity ='';
            this.originPincode ='';
            this.groupname ='';
            this.groupID ='';
            this.sourcetype =null;
            this.user = {
                originCountry : '',
                originState : '',
                originCity : '',
                origin_Pincode : '',
                originWeekoff :[],
                selectedstatus:null,
                constraint_id :[]
            }
            this.item_state = [];
            this.StateList = [];
            this.item_city = [];
            this.CityList = [];
            this.item_pincode = [];
            this.PincodeList = [];
            this.originmasterlist(this.pageNum)
            this.getStateList('country')
            this.clientnamelist =[];
            this.clientname =[];
            this.allclientlist()   
        },

        clear(){
            this.pageNum=1;
            this.totalRows = 0;
            this.customer ={
                originCountry : '',
                originState : '',
                originCity : '',
                originPincode : '',
                originWeekoff :[],
                selectedstatus:null,
                constraint_id :[]
            }
            this.originName ='';
            this.originCity ='';
            this.originPincode ='';
            this.groupname ='';
            this.groupID ='';
            this.sourcetype =null;
            this.user = {
                originCountry : '',
                originState : '',
                originCity : '',
                origin_Pincode : '',
                originWeekoff :[],
                selectedstatus:null,
                constraint_id :[]
            }
            this.item_state = [];
            this.StateList = [];
            this.item_city = [];
            this.CityList = [];
            this.item_pincode = [];
            this.PincodeList = [];
            this.originmasterlist(this.pageNum)
            this.getStateList('country')
            this.clientnamelist =[];
            this.clientname =[];
            this.allclientlist()   
        },

        allclientlist(){
            const Obj = {}
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getallclientlist`,Obj)
            .then((result) => {
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    this.clientnamelist = result.body.returnvalue;

                    this.clientnamelist.forEach(value => {
                        var client = {
                            key:value.clientmasterid,
                            label:value.clientname
                        }
                        this.clientname.push(client)
                        if (value.clientmasterid==27 && value.clientname=="Firstcry") {
                            this.customer.ClientName = client;
                        }
                    });
            
                } else {
                    this.clientnamelist =[];
                    this.clientname =[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then((result) => {
                console.log("-----------",result)
                if (result) {
                    this.addoriginmasterinfo();
                }
            });
        },

        addoriginmasterinfo(){
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj = {
                sysusermasterid : userInfo.sysusermasterid,
                client_id : this.customer.ClientName==null?'':this.customer.ClientName.key,
                origin_type : this.customer.originType,
                origin_name : this.customer.originName,
                origin_id : this.customer.originID,
                origin_country : this.customer.originCountry,
                origin_state : this.customer.originState,
                origin_city : this.customer.originCity,
                origin_pincode : this.customer.originPincode,
                origin_address : this.customer.originAddress,
                origin_weekoof :this.customer.originWeekoff,
                origin_emailid : this.customer.originMailId,
                origin_phone : this.customer.originPhone,
                origin_poc : this.customer.originPoc,
                origin_latlng : this.customer.originLatLong,
                createdby : `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                isactive : this.customer.selectedstatus,
                constraint_id : this.customer.constraint_id,
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/addrboriginmaster`,Obj)
            .then((result) => {
                console.log(result);
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 30000,
                });
                this.add_origininfo = false;
                this.originmasterlist(this.pageNum)
                this.clear();
                this.customer = {};
                this.clientnamelist =[];
                this.clientname =[];
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        clickCallback (pageNum){
            this.listingpageno = pageNum;
            this.originmasterlist(pageNum);
        },

        originmasterlist(pageNum){
            this.items =[];
            this.totalRows =0;
            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj = {
                sysusermasterid :userInfo.sysusermasterid,
                page_no : pageNum,
                origin_name : this.originName.trim(),
                origin_type : this.sourcetype==null?"":this.sourcetype,
                origin_city : this.originCity.trim(),
                origin_pincode : this.originPincode.trim(),
                origin_group_name:this.groupname,
                origingroup_id: this.groupID,
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getoriginmasterList`,Obj)
            .then((result) => {
                this.isBusy=false;
                if (result.body.returnmsg === "Successful") {
                    this.items = result.body.returnvalue;
                    this.totalRows = result.body.totalCount;
                    this.noofpages=parseInt(this.totalRows)/20;
                    this.noofpages=Math.ceil( this.noofpages);
            
                } else {
                    this.items =[];
                    this.totalRows =0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        ConstraintList(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj = {}
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getconstraintmasterList`,Obj)
            .then((result) => {
                if (result.body.returnmsg === "Successful") {
                    this.items_ConstraintList = result.body.returnvalue;
                    this.items_ConstraintList.forEach(value => {
                        var constrainlist={
                            key:`${value.constraint_id}`,
                            label:value.rb_constraint
                        }
                        this.constrainlist.push(constrainlist)
                    });
                
                } else {
                    this.items_ConstraintList =[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        editoriginmodelopen(data){
            this.user={}
            this.add_origininfo=false;
            this.search_origin=false;
            this.origin_masterid='';
            this.user = {
                originWeekoff :[],
                selectedstatus:null,
                constraint_id :[]
            }

            this.user.ClientName = data.clientname;
            if (this.user.ClientName) {
                this.handleClientNameChange( this.user.ClientName)
            }
            this.user.originType = data.origin_type;
            this.user.originName = data.origin_name;
            this.user.originID = data.origin_id;
            this.user.originCountry = data.origin_country;
            if (data.origin_country!=null && data.origin_country!=undefined) {
                this.editstatelist('country',this.user.originCountry)
            }   
            this.user.originState = data.origin_state;
            if (data.origin_state!=null && data.origin_state!=undefined) {
                this.editcitylist('city',this.user.originCountry,this.user.originState)
            }   
            this.user.originCity = data.origin_city;
            if (data.origin_city!=null && data.origin_city!=undefined) {
                this.editpincodelist('pincode',this.user.originCountry,this.user.originState,this.user.originCity)
            }   
            this.user.originPincode = data.origin_pincode;
            this.user.originAddress = data.origin_address;
            this.user.originMailId = data.origin_emailid;
            this.user.originPhone = data.origin_phone;
            this.user.originPoc = data.origin_poc;
            if (data.origin_latlng) {
                this.user.originLatLong = data.origin_latlng.replace(/[\(\)']+/g,'');   
            }

            if (data.constraint_id) {
                var destext = data.constraint_id.split(',')
                this.user.constraint_id = destext;
            }

            if (data.origin_weekoof) {
                var text = data.origin_weekoof.split(',')
                this.user.originWeekoff= text;
            }
            this.user.selectedstatus = data.isactive;
            this.origin_masterid = data.id;
            this.showoriginModal=!this.showoriginModal
        },

        handleconstraintChange: function(event){
            console.log('Selected constraint changed:', event.value);
        },

        handleSelectionChange: function(event) {
            console.log('Selected week changed:', event.value);
        },

        handleClientNameChange(selectedValue) {
        const selectedKeyObject = this.findKeyObjectByLabel(selectedValue);
            // Do something with the selected key object
            console.log('Selected key object:', selectedKeyObject);
            this.user.ClientName = selectedKeyObject;
        },

        findKeyObjectByLabel(label) {
            return this.clientname.find(item => item.label === label) || null;
        },

        validateForm1(scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    this.editorigininfo();
                }
            });
        },

        editorigininfo(){
            document.getElementById("overlaymodel").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj = {
                origin_masterid : this.origin_masterid,
                sysusermasterid : userInfo.sysusermasterid,
                client_id : this.user.ClientName==null?'':this.user.ClientName.key,
                origin_type : this.user.originType,
                origin_name : this.user.originName,
                origin_id : `${this.user.originID}`,
                origin_country : this.user.originCountry,
                origin_state : this.user.originState,
                origin_city : this.user.originCity,
                origin_pincode : this.user.originPincode,
                origin_address : this.user.originAddress,
                origin_weekoof :this.user.originWeekoff,
                origin_emailid : this.user.originMailId,
                origin_phone : this.user.originPhone,
                origin_poc : this.user.originPoc,
                origin_latlng : this.user.originLatLong,
                lastmodifiedby : `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                isactive : this.user.selectedstatus,
                constraint_id : this.user.constraint_id,
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/editrboriginmaster`,Obj)
            .then((result) => {
                console.log(result);
                document.getElementById("overlaymodel").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 30000,
                });
                this.showoriginModal = false;
                this.originmasterlist(this.pageNum)
                this.clear();
                this.user = {};
                this.clientnamelist =[];
                this.clientname =[];
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
        
        // add start
        selectcountry(value,data){
            if (value=='country') {
                this.getStateList('country')
            }
            // if (value=='state') {
            //     this.getStateList('state',country)
            // }
            if (data==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.originCountry='';
                this.customer.originState='';
                this.customer.originCity='';
                this.customer.originPincode='';
            }
        },
        
        selectstate(value,country,state){
            if (value=='city') {
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.originCity='';
                this.customer.originPincode='';
                this.customer.originPincode=null;
                this.getStateList('city',country,state)
            }
            if (state==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.originState='';
                this.customer.originCity='';
                this.customer.originPincode='';
                this.customer.originPincode=null;
                this.getStateList('country')
            }
        },

        selectcity(value,country,state,city){
            if (value=='pincode') {
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.originPincode='';
                this.customer.originPincode=null;
                this.getStateList('pincode',country,state,city)
            }
            if (city==null) {
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.originCity='';
                this.customer.originPincode='';
                this.customer.originPincode=null;
                this.getStateList('city',country,state)
            }
        },
        // add end

        editstatelist(value,data){
            if (value=='country') {
                this.getStateList('country')
            }
            if (data==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.originCountry='';
                this.user.originState ='';
                this.user.originCity='';
                this.user.originPincode='';
                this.user.originPincode=null;
            }
        },

        editcitylist(value,country,state){
            if (value=='city') {
                this.user.originCity='';
                this.user.originPincode='';
                this.user.originPincode=null;
                this.getStateList('city',country,state)
            }
            if (state==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.originState ='';
                this.user.originCity='';
                this.user.originPincode='';
                this.user.originPincode=null;
                this.getStateList('country')
            }
        },

        editpincodelist(value,country,state,city){
            console.log(value,country,state,city)
            if (value=='pincode') {
                this.user.originPincode='';
                this.user.originPincode=null;
                this.getStateList('pincode',country,state,city)
            }
            if (city==null) {
                this.item_city = [];
                this.CityList = [];
                // console.log
                this.user.originPincode='';
                this.user.originPincode=null;
                // console.log("this.user.originPincode",this.user.originPincode)
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.originCity='';
                this.getStateList('city',country,state)
            }
        },

        getStateList(value,country,state,city){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            if (value=='country') {
                this.Obj = {
                    country : "",
                    state : "",
                    city : "",
                    pincode : ""
                }
            }

            if (value=='city') {
                this.Obj = {
                    country : "",
                    state : state,
                    city : "",
                    pincode : ""
                }
            }

            if (value=='pincode') {
                this.Obj = {
                    country : "",
                    state : state,
                    city : city,
                    pincode : ""
                }
            }

            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getStateCityPincodes`,this.Obj)
            .then((result) => {
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    if (value=='country') {
                        this.item_state = [];
                        this.StateList = [];
                        this.item_city = [];
                        this.CityList = [];
                        this.item_pincode = [];
                        this.PincodeList = [];
                        this.item_state = result.body.returnvalue;
                        this.item_state.forEach(value => {
                            this.StateList.push(value.state)
                        });
                    }

                    if (value=='city') {
                        this.item_city = [];
                        this.CityList = [];
                        this.item_pincode = [];
                        this.PincodeList = [];
                        this.item_city = result.body.returnvalue;
                        this.item_city.forEach(value => {
                            this.CityList.push(value.city)
                        });
                    }

                    if (value=='pincode') {
                        this.item_pincode = [];
                        this.PincodeList = [];
                        this.item_pincode = result.body.returnvalue;
                        this.item_pincode.forEach(value => {
                            this.PincodeList.push(value.pincode)
                        });
                    }
                } 
                else {
                    this.item_state = [];
                    this.StateList = [];
                    this.item_city = [];
                    this.CityList = [];
                    this.item_pincode = [];
                    this.PincodeList = [];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>